import React, { Fragment } from 'react';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';

import { getRedirectToIfNeeded, handleRedirectTo } from '../utils/navigationUtils';

// NOTE: routing seems to be empty using routerReducer from react-router-redux sometimes
// routing.location.search will not process unescaped hashes.
// Example: ?address=123 hello st #345 admiral st will result in
// { routing.location.search: "?123 hello st", routing.location.hash: "#345 admiral st" }

class AuthCheck extends React.Component {
  constructor(props) {
    super(props);

    this.initialRedirectUrl = getRedirectToIfNeeded(props);

    if (this.initialRedirectUrl) {
      props.onRedirectCallback(this.initialRedirectUrl);
    }
  }

  componentDidMount() {
    if (this.props.isReadyToClientSideRedirect) {
      this.handleNotLoggedIn();
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps, this.props)) {
      if (this.props.isReadyToClientSideRedirect) {
        this.handleNotLoggedIn();
      }
    }
  }

  componentWillUnmount() {
    const { onCleanUp } = this.props;
    if (onCleanUp) {
      onCleanUp();
    }
  }

  handleNotLoggedIn = () => {
    const { userToken, loggedIn, email, hasStrongAuthentication, onNotLoggedIn } = this.props;

    const redirectUrl = getRedirectToIfNeeded(this.props);

    if (redirectUrl) {
      if (onNotLoggedIn) {
        onNotLoggedIn(redirectUrl);
      } else {
        handleRedirectTo(
          {
            userToken,
            loggedIn,
            email,
            hasStrongAuthentication,
          },
          redirectUrl,
        );
      }
    }
  };

  render() {
    const { children } = this.props;

    return <Fragment>{!this.initialRedirectUrl && children}</Fragment>;
  }
}

AuthCheck.defaultProps = {
  zillowCustomLoginPagePath: '',
};

AuthCheck.propTypes = {
  brand: PropTypes.string,
  loggedIn: PropTypes.bool,
  isTwoFactorAuthEnabled: PropTypes.bool,
  isTwoFactorAuthenticated: PropTypes.bool,
  isReadyToClientSideRedirect: PropTypes.bool,
  hasStrongAuthentication: PropTypes.bool,
  routing: PropTypes.object,
  userToken: PropTypes.string,
  impersonatorUserToken: PropTypes.string,
  impersonatorEmail: PropTypes.string,
  onCleanUp: PropTypes.func,
  onNotLoggedIn: PropTypes.func,
  onRedirectCallback: PropTypes.func,
  isInWebView: PropTypes.bool,
  // TODO: remove once this is no longer needed (i.e we can replace old zillow login page with zrm login page for good)
  zillowCustomLoginPagePath: PropTypes.string,
};

export default AuthCheck;
